import { MemorySearchSettings } from '../memory-search-client/memory-search-client';

export interface EmbedItemsSourceSettings extends MemorySearchSettings {
  type: 'embed-items';
}
